"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataListTable = void 0;
var React = require("react");
var utils_1 = require("../../utils");
var editablelist_1 = require("../editableList/editablelist");
var paginatorList_1 = require("../editableList/paginatorList");
var mobx_react_1 = require("mobx-react");
var DataListTable = (function (_super) {
    __extends(DataListTable, _super);
    function DataListTable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.rowClickHandler = function (event, object_id) { };
        _this.refetchTable = function (event) {
            var params = window.location.search;
            if (event) {
                (0, utils_1.preventDefault)(event);
                var url = new URL(event.currentTarget.href);
                var search = new URLSearchParams(url.search);
                params = "?" + search.toString();
            }
            window.history.pushState(null, null, window.location.pathname + params);
            _this.props.data_list.fetchData(params);
            _this.props.data_list.filter_state.fetchData();
        };
        return _this;
    }
    DataListTable.prototype.performBulkUpdate = function (selected, values) {
        values[this.props.bulk_update_param] = selected;
        return this.props.data_list.updateRows(values);
    };
    DataListTable.prototype.performQuickAdd = function (values) {
        return this.props.data_list.createNew(values);
    };
    DataListTable.prototype.performRowUpdate = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2, this.props.data_list.updateRows(data).then(function (response) {
                        notification(response.message);
                    })];
            });
        });
    };
    DataListTable.prototype.render = function () {
        return (React.createElement("div", { className: this.props.html_id + "Table" },
            React.createElement(editablelist_1.EditableList, { columns: this.props.data_list.data.columns, headers: this.props.data_list.data.headers, rows: this.props.data_list.data.rows, rowClickHandler: this.rowClickHandler, performRowUpdate: this.performRowUpdate.bind(this), refetchTable: this.refetchTable, allowBulkEditing: this.props.data_list.data.bulk_edit_fields.length > 0, performBulkUpdate: this.performBulkUpdate.bind(this), bulkEditFields: this.props.data_list.data.bulk_edit_fields, allowQuickAdd: this.props.data_list.data.quick_add_fields.length > 0, performQuickAdd: this.performQuickAdd.bind(this), quickEditFields: this.props.data_list.data.quick_add_fields, headerSortClickHandler: this.refetchTable, bulkMenuState: this.props.data_list.bulk_menu_state.data, updateBulkMenuState: this.props.data_list.bulk_menu_state.getFetchDataMethod() }),
            React.createElement("div", { className: this.props.html_id + "Table__Footer" },
                React.createElement(paginatorList_1.default, { paginator: this.props.data_list.data.paginator, click: this.refetchTable }))));
    };
    DataListTable = __decorate([
        mobx_react_1.observer
    ], DataListTable);
    return DataListTable;
}(React.Component));
exports.DataListTable = DataListTable;
